import { useEffect, useRef } from "react";

import { useAppSelector } from "~/app/store";
import { collectPongData } from "~/features/andon/heartbeat/heartbeat.logic";
import { hubs } from "~/lib/signalr";
import { selectIsUserLoggedIn } from "~/redux/selectors/authSelectors";

export function useSendInitialPongOnce() {
  const hasSentInitialPongRef = useRef(false);

  const siteWorkstation = useAppSelector(
    (state) => state.workstations.siteWorkstation
  );
  const isUserLoggedIn = useAppSelector(selectIsUserLoggedIn);
  const signalREnabled = useAppSelector((state) => state.app.signalREnabled);
  const signalRReady = useAppSelector(
    (state) => state.app.ready.signalr.main || state.app.ready.signalr.andon
  );

  useEffect(() => {
    const send = async () => {
      if (!siteWorkstation || !signalRReady || hasSentInitialPongRef.current)
        return;

      const pongData = await collectPongData({
        workstationDeviceId: siteWorkstation.deviceId
      });

      hubs.send.next({
        case: "Pong",
        item: {
          connection: pongData,
          sourceWorkstationId: siteWorkstation.id,
          timePingSent: new Date()
        }
      });

      hasSentInitialPongRef.current = true;
    };

    if (isUserLoggedIn && signalREnabled) {
      void send();
    }
  }, [isUserLoggedIn, signalREnabled, signalRReady, siteWorkstation]);
}
